// extracted by mini-css-extract-plugin
export default {"pdf_container":"PDFPreview_pdf_container__T5mf1","pdf_page":"PDFPreview_pdf_page__GRoiF"};